"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_router_1 = require("react-router");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const requestDetail_1 = __importDefault(require("../../request/newRequest/requestDetail"));
const RequestInfoAside = ({ openAside = false, asideTitle = '', request, onClose = () => ({}), }) => {
    const navigate = (0, react_router_1.useNavigate)();
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "view-conversation-btn", color: uiConstants_1.UI_BUTTON_PRIMARY, style: { marginBottom: '10px' }, onClick: () => {
                    void navigate(`/requests/${request?.requestId}`);
                }, label: strings_1.walletStrings.VIEW_CONVERSATION_BUTTON }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", color: uiConstants_1.UI_BUTTON_SECONDARY, style: { marginBottom: '10px' }, onClick: onClose, label: strings_1.inputStrings.CANCEL })] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "request-info", title: asideTitle, open: openAside, onClose: onClose, footerButtons: footerButtons, children: (0, jsx_runtime_1.jsx)(material_1.Box, { sx: [
                {
                    margin: 1,
                },
                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? {
                        boxShadow: '0 5px 10px rgba(136, 158, 169, 0.15)',
                        border: '1px solid #E7ECEF',
                    }
                    : {},
            ], children: (0, jsx_runtime_1.jsx)(requestDetail_1.default, { requestForApproval: request }) }) }));
};
exports.default = RequestInfoAside;
